<template>
	<div
		class="column-filter-container"
		@click="toggleColumnFilter"
	>
		<r-standard-icon
			class="field-icon"
			icon="watchfulEye"
			:hexColor="eyeIconColor"
		></r-standard-icon>
		<universal-field-label-display						
			:dataStore="sheetView.sheetViewGroup.dataStore"
			:fieldGUID="fieldGUID"
		/>
		<!-- <div class="field-label">{{ fieldStruct.properties.display.label }}</div> -->
	</div>
</template>
<script>

import UniversalFieldLabelDisplay from 'vue/sheet-views/common/fields/universal-field-label-display';	

export default {
	name:'filter-field-toggle',
	data(){
		return{
		};
	},
	components:{
		UniversalFieldLabelDisplay,
	},
	props:{
		sheetView:{
			required: true,
			type: Object,
		},
		fieldGUID:{
			required: true, 
			type: String,
		},
		// True if we are the first column
		override:{
			required: false,
			type: Boolean,
			default: false,
		},
		// Contains an anchorFieldGUID and a direction: 0 for left, 1 for right
		setRelativeColumnLocation:{
			required: false,
			type: Object
		}
	},
	computed:{
		ownFilterIsApplied(){
			return (this.sheetView.properties.fields.shownFields.indexOf(this.fieldGUID) >= 0)
		},
		eyeIconColor(){
			if(this.override){
				return '#2C2C37';
			}
			else if(this.ownFilterIsApplied){
				return `#2F80ED`;
			}
			else{
				return '#C3C9D4';
			}
		},
	},
	methods:{
		toggleColumnFilter(){
			if(!this.override){
				if(this.ownFilterIsApplied){
					this.sheetView.unshowField(this.fieldGUID);
				}
				else{
					this.sheetView.showField(this.fieldGUID);

					// Account for chosen direction and anchor guid
					// when showing the new field
					if (this.setRelativeColumnLocation) {
						this.sheetView.addColumnInSortedOrder(this.fieldGUID, this.setRelativeColumnLocation.anchorFieldGUID, this.setRelativeColumnLocation.direction);
					}
				}
			}
		},
	},
}

</script>
<style scoped lang="scss">
	
.column-filter-container{
	@include flex(row, flex-start);
	width: 100%;
	height: 36px;
	cursor: pointer;

	&:hover{
		background: $p-color-grey-100;
	}

	&:active{
		filter: brightness(98%);
	}

	.field-icon{
		margin-left: 6px;
		margin-right: 6px;
	}

	.field-label{
		font-family: $rvFontFamily;
		font-weight: 400;
		font-size: 14px;
		line-height: 20px;
		letter-spacing: 0.15px;
		color: $p-color-grey-600;
	}
}


</style>
